import { type FeatureModule } from '@store/features/types';

import { guideDrawerReducer } from './guideDrawerSlice';

export const knowledgeBaseFeature: FeatureModule = {
  id: 'knowledge-base',
  name: 'Knowledge base reader',
  reducers: { guideDrawer: guideDrawerReducer },
};
